import styled from 'styled-components';
import { rem } from '../../utils';
export const StyledWrapper = styled.div `
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
`;
export const StyledList = styled.ul `
  display: flex;
  gap: ${({ theme }) => rem(theme.Spacing.Size.Small)};
  flex-flow: column;
  width: 100%;
  flex-wrap: wrap;
  list-style: none;
  padding: 0;
  margin: 0;
  justify-content: center;
`;
export const StyledListItem = styled.li `
  display: inline-flex;
  width: 100%;
`;
//# sourceMappingURL=CollectionTilesGroup.style.js.map